import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { companyInfo, services } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={companyInfo.logo} alt={companyInfo.name} className="h-12 w-12 object-contain" />
              <h3 className="text-xl font-bold">{companyInfo.name}</h3>
            </div>
            <p className="text-gray-400 mb-4">
              Your trusted travel partner in Varanasi. Safe, affordable, and reliable taxi services available 24/7.
            </p>
            <div className="flex gap-4">
              <a href="#" className="bg-orange-600 p-2 rounded-full hover:bg-orange-700 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="bg-orange-600 p-2 rounded-full hover:bg-orange-700 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="bg-orange-600 p-2 rounded-full hover:bg-orange-700 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange-500">Our Services</h3>
            <ul className="space-y-2">
              {services.slice(0, 6).map((service, index) => (
                <li key={index} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange-500">Quick Links</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">About Us</li>
              <li className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Our Fleet</li>
              <li className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Destinations</li>
              <li className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Contact Us</li>
              <li className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Terms & Conditions</li>
              <li className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">Privacy Policy</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange-500">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-orange-500 flex-shrink-0 mt-1" />
                <p className="text-gray-400 text-sm">{companyInfo.address}</p>
              </div>
              {companyInfo.phone.map((phone, index) => (
                <div key={index} className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <a href={`tel:${phone}`} className="text-gray-400 hover:text-orange-500 transition-colors">
                    {phone}
                  </a>
                </div>
              ))}
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-orange-500 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-orange-500 transition-colors text-sm break-all"
                >
                  {companyInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} {companyInfo.name}. All rights reserved. | Best Taxi Service in Varanasi
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
